import React from 'react';
import Title from 'components/Text/Title';

export default function OneMoment() {

    const containerStyles = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: 400,
        height: 175,
        paddingTop: 200,
    };

    return <div style={containerStyles}><Title>One moment please ...</Title></div>;
}